export const state = {
  departement: undefined,
  departements: [],
  communes: [],
  arrondissements: [],
  villes: [],
  nations: [],
  sousDepartement: undefined,
  sousDepartements: []
}